import { render } from "./MainNavMenu.vue?vue&type=template&id=9a6325e4&scoped=true"
import script from "./MainNavMenu.vue?vue&type=script&lang=js"
export * from "./MainNavMenu.vue?vue&type=script&lang=js"

import "./MainNavMenu.vue?vue&type=style&index=0&id=9a6325e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a6325e4"]])

export default __exports__